import { IProgram } from '../../../types/mortgage';

interface IParams {
  startProjectPrice?: number;
  programs?: IProgram[];
}

const DEFAULT_INITIAL_PRICE = 5000000;

const DEFAULT_INITIAL_PAYMENT_PERCENT = 0.2;

const DEFAULT_RATE = 3;

const DEFAULT_PAYMENT_PERIOD = 20;

export const getInitialMortgageValues = ({ startProjectPrice, programs }: IParams) => {
  let defaultInitialPrice = DEFAULT_INITIAL_PRICE;
  let minRate = DEFAULT_RATE;

  if (programs) {
    // Находим программу с минимальной процентной ставкой
    const { rate: programRate, creditLimitMillions } = programs.reduce<IProgram>((minProgram, currentProgram) => {
      return !minProgram.rate || currentProgram.rate < minProgram.rate ? currentProgram : minProgram;
    }, {} as IProgram);

    defaultInitialPrice = creditLimitMillions * 1000000;
    minRate = programRate;
  }

  const initialPrice = startProjectPrice ?? defaultInitialPrice;

  const initialPayment = initialPrice * DEFAULT_INITIAL_PAYMENT_PERCENT;

  return { initialPrice, initialPayment, minRate, initialPeriod: DEFAULT_PAYMENT_PERIOD };
};
